import * as z from 'zod';

import { InsuranceFields } from '../sharedFields/InsuranceFields';
import { MultiPropertyInsuranceFields } from '../sharedFields/MultiplePropertyInsuranceFields';
import { ArmFields } from './ArmFields';
import { AuthorizedContactFields } from './AuthorizedContactFields';
import { AllBorrowerFields } from './BorrowerFields';
import { DeprecatedInsuranceFields, DeprecatedMultipleAddressesInsuranceFields } from './DeprecatedInsuranceFields';
import { MortgageInsuranceFields } from './MortgageInsuranceFields';
import { RemittanceFields } from './RemittanceFields';
import { MultipleAddressesTaxFields, TaxFields } from './TaxFields';

// By doing the merge here and only exporting a single type
// it appears to get rid of the following TS error:
//
// Recursive type: Type instantiation is excessively deep and possibly infinite.

export const CreateLoanMultipleAddressFields = z.object({
  ...DeprecatedMultipleAddressesInsuranceFields.shape, // TODO deprecate
  ...MultipleAddressesTaxFields.shape,
  ...MultiPropertyInsuranceFields.shape,
});
export type CreateLoanMultipleAddressFields = z.infer<typeof CreateLoanMultipleAddressFields>;

export const CreateLoanFields = z.object({
  ...MortgageInsuranceFields.shape,
  ...AllBorrowerFields.shape,
  ...AuthorizedContactFields.shape,
  ...DeprecatedInsuranceFields.shape, // TODO deprecate
  ...InsuranceFields.shape,
  ...RemittanceFields.shape,
  ...TaxFields.shape,
  ...ArmFields.shape,
});
export type CreateLoanFields = z.infer<typeof CreateLoanFields>;
